module.exports = __webpack_public_path__ + "static/media/LogoTest.9775b9c3.svg";